/** Generated by packages/core/scripts/generate-i18n-locales.ts — do not edit. */

import { registerI18n } from '@videojs/core/i18n';
import translations from '@videojs/core/i18n/locales/hu';

registerI18n('hu', translations);
